<script setup lang="ts">
import { computed } from "vue";

const props = withDefaults(
  defineProps<{
    message: string;
    link?: string;
    linkClass?: string;
    linkSource?: string;
    linkMedium: string;
    linkCampaign: string;
    target?: string;
  }>(),
  {
    link: "https://app.controla.ai",
    linkClass: "",
    linkSource: "website",
    target: "_blank",
  },
);

const computedLink = computed(() => {
  try {
    const url = new URL(props.link);
    // UTM params only make sense for links that open a web page. Appending
    // them to mailto:/tel: URIs re-serializes the query as form-encoded
    // (mangling the subject) and adds junk as email headers.
    if (url.protocol !== "http:" && url.protocol !== "https:") {
      return props.link;
    }
    if (props.linkSource !== "") {
      url.searchParams.set("utm_source", props.linkSource);
    }
    if (props.linkMedium) {
      url.searchParams.set("utm_medium", props.linkMedium);
    }
    if (props.linkCampaign) {
      url.searchParams.set("utm_campaign", props.linkCampaign);
    }

    return url.toString();
  } catch (e) {
    console.error("Failed to compute link", e);

    return props.link;
  }
});
</script>

<template>
  <a
    class="inline-flex flex-col items-center justify-center rounded-pill bg-primary-black px-4 py-3 text-sm font-medium text-white"
    :class="linkClass"
    :href="computedLink"
    :target="target"
  >
    {{ message }}
  </a>
</template>

<style scoped lang="css"></style>
